import Vue from 'vue'
import job from './job'
import project from './project'
import purchaseOrder from './purchaseOrder'
import search from './search'
import {make} from 'vuex-pathify'

const initialState = {
    // types: []
}

const state = Vue.util.extend({}, initialState)

const getters = make.getters(state)
const mutations = make.mutations(state)


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions: {
    },
    modules: {
        project,
        purchaseOrder,
        search,
        job
    }
}